
<div class="row">
  <div class="col-lg-3" style="position: absolute; height: 95%">
    <div class="col-lg-10" style="padding-top: 15px;">
      <span class="p-float-label width-100">
        <input id="float-input"
                (keyup)="filter($event)"
                type="search"
                class="width-100"
                pInputText />
        <label for="float-input">Type the topic you are looking for</label>
      </span>
    </div>
    <div class="col-lg-12"
          style=" position: sticky;
                  overflow-y: scroll;
                  overflow-x: hidden;
                  top: 120px;
                  height: 85%;
                ">
      <ul class="list-unstyled userManual">
        <li *ngFor="let manual of userManuals"
            [ngClass]="{ 'userManual-selected': manual.selected }"
            (click)="showHelp(manual)">
          <i class="left fas fa-angle-right"></i>
          {{ manual.name }}
        </li>
      </ul>
    </div>
  </div>
  <div class="col-lg-9"
        style="
    position: absolute;
    height: 85%;
    margin-left: 26.1%;
    border-left: 1px solid lightgray;
  ">
    <div *ngIf="helpSrc" class="row" style="padding: 5px; padding-top:15px;">
      <div class="col-lg-10"></div>
      <div class="col-lg-2">
        <button [margin-right]="8"
                pButton
                icon="fas fa-save"
                style="width:90px;"
                type="button"
                pTooltip="Download file"
                prevent-click
                label="{{ 'general.save' | gstranslate }}"
                (click)="downloadFile()"></button>
        <a #downloadLink href="#"></a>
      </div>      
    </div>
    <pdf-viewer *ngIf="helpSrc"
                [src]="helpSrc"
                [original-size]="true"
                [fit-to-page]="true"
                [render-text]="false"></pdf-viewer>
  </div>
</div>
